import { useState } from 'react';

export default function HVACFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'How often should I service my HVAC system in El Paso?',
      answer: 'In El Paso\'s climate, it\'s recommended to service your AC system twice a year - once before summer and once before winter. Regular maintenance helps prevent breakdowns during extreme temperatures and extends your system\'s lifespan.'
    },
    {
      question: 'What size HVAC system do I need for my El Paso home?',
      answer: 'The right size depends on your home\'s square footage, insulation, ceiling height, and window placement. A professional HVAC contractor will perform a load calculation to determine the correct size. Oversized or undersized systems can lead to inefficiency and comfort issues.'
    },
    {
      question: 'How much does HVAC installation cost in El Paso?',
      answer: 'HVAC installation costs in El Paso typically range from $3,500 to $12,000, depending on system type, size, and complexity. Central AC systems average $5,000-$8,000, while heat pumps and high-efficiency systems may cost more. Always get multiple quotes for comparison.'
    },
    {
      question: 'What SEER rating should I choose for El Paso\'s climate?',
      answer: 'For El Paso\'s hot climate, a SEER rating of 16 or higher is recommended for optimal efficiency and cost savings. Higher SEER ratings mean better energy efficiency, which is crucial during long, hot summers. Many contractors recommend SEER 18-20 for maximum savings.'
    },
    {
      question: 'Do I need a permit for HVAC installation in El Paso?',
      answer: 'Yes, HVAC installations in El Paso typically require permits from the city. Licensed contractors will handle permit applications and ensure work meets local building codes. This protects you and ensures proper installation standards are followed.'
    },
    {
      question: 'How long does an HVAC system last in El Paso?',
      answer: 'With proper maintenance, AC systems in El Paso typically last 12-15 years, while furnaces can last 15-20 years. El Paso\'s intense heat and frequent use can reduce lifespan, making regular maintenance even more important for longevity.'
    },
    {
      question: 'What are signs I need HVAC repair?',
      answer: 'Common signs include unusual noises, weak airflow, inconsistent temperatures, high energy bills, frequent cycling, and strange odors. If you notice any of these issues, contact a licensed HVAC contractor immediately to prevent further damage.'
    },
    {
      question: 'Should I repair or replace my HVAC system?',
      answer: 'Consider replacement if your system is over 10 years old, requires frequent repairs, or repair costs exceed 50% of replacement cost. Newer systems are more energy-efficient and can save significantly on utility bills, often paying for themselves over time.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-600">
            Common questions about HVAC services in El Paso
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-orange-50 to-white rounded-xl border-2 border-orange-100 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left hover:bg-orange-50 transition-colors"
              >
                <h4 className="text-lg font-bold text-gray-900 pr-8">
                  {faq.question}
                </h4>
                <i className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-2xl text-orange-600 flex-shrink-0`}></i>
              </button>
              {openIndex === index && (
                <div className="px-8 pb-6">
                  <p className="text-gray-700 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
